module.exports = __webpack_public_path__ + "3cc97954018d797b3d3e2b6afa74e0cd.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BS.svg
// module id = 7NX6
// module chunks = 0